import React from 'react';
import { EmergencyContactConfig } from '../../types/submission';

interface EmergencyContactSectionProps {
  config: EmergencyContactConfig;
  onConfigChange: (config: EmergencyContactConfig) => void;
  deadline?: string;
  disabled?: boolean;
  language?: string;
}

const EmergencyContactSection: React.FC<EmergencyContactSectionProps> = ({
  config,
  onConfigChange,
  deadline,
  disabled = false,
  language = 'de'
}) => {
  const handleEnabledChange = (enabled: boolean) => {
    onConfigChange({
      ...config,
      enabled,
      deadline: enabled ? deadline : ''
    });
  };

  const translations = {
    de: {
      title: 'Notfallkontakt mitversenden',
      description: 'Verwendet die gleiche Deadline wie der Hauptfragebogen'
    },
    en: {
      title: 'Include Emergency Contact',
      description: 'Uses the same deadline as the main questionnaire'
    }
  };

  const t = translations[language as 'de' | 'en'] || translations.de;

  return (
    <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
      <label className="flex items-start space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={config.enabled}
          onChange={(e) => handleEnabledChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
          disabled={disabled}
        />
        <div className="flex-1">
          <div className="text-xs font-medium text-red-900">
            {t.title}
          </div>
          <div className="text-xs text-red-700 mt-1">
            {t.description}
          </div>
        </div>
      </label>
    </div>
  );
};

export default EmergencyContactSection;
